import { IState } from '../../store';

export function onlyCianSelector(state: IState): boolean {
  return state.offerData.offer.isUnique || false;
}
